import { render, staticRenderFns } from "./UpgradedTicketsList.vue?vue&type=template&id=3742e53d"
import script from "./UpgradedTicketsList.vue?vue&type=script&lang=js"
export * from "./UpgradedTicketsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports